import { render, staticRenderFns } from "./TimelineUserWithPrivilegesInteraction.vue?vue&type=template&id=8dcb4964&scoped=true"
import script from "./TimelineUserWithPrivilegesInteraction.vue?vue&type=script&lang=ts"
export * from "./TimelineUserWithPrivilegesInteraction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcb4964",
  null
  
)

export default component.exports